import {
  MessageConfig, MessageType,
} from '@routific/hive';

export const GEOCODE_PENDING_MSG_KEY = 'geocode-pending';

export const geocodingMessage = (geocodingCount: number): MessageConfig => ({
  key: GEOCODE_PENDING_MSG_KEY,
  type: MessageType.LOADING,
  content: `Plotting orders on the map (${geocodingCount} remaining)`,
  dataCy: 'geocoding-message',
  duration: 0,
});
